import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const categories = [
  { name: "Shoes", url: "https://repsw2c.com/category-911-Shoes.html" },
  { name: "Hoodies/Sweaters", url: "https://repsw2c.com/search-912/name/Shoes.html" },
  { name: "T-Shirts", url: "https://repsw2c.com/search-913/name/Shoes.html" },
  { name: "Jackets", url: "https://repsw2c.com/search-914/name/Shoes.html" },
  { name: "Pants/Shorts", url: "https://repsw2c.com/search-915/name/Shoes.html" },
  { name: "Headwear", url: "https://repsw2c.com/search-916/name/Shoes.html" },
  { name: "Sets", url: "https://repsw2c.com/search-917/name/Shoes.html" },
  { name: "Underwear/Underpants", url: "https://repsw2c.com/search-918/name/Shoes.html" },
  { name: "Jersey", url: "https://repsw2c.com/search-919/name/Shoes.html" },
  { name: "Accessories", url: "https://repsw2c.com/search-920/name/Shoes.html" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="https://static.readdy.ai/image/751042991eee80e3d0f5ce87d83ca658/767f58c2250624902df30344d9bb9bad.png"
              alt="ACBuy2026 Logo"
              className="h-10 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <a
              href="#home"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? "text-gray-700 hover:text-gray-900" : "text-white hover:text-gray-200"
              }`}
            >
              Home
            </a>

            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                onBlur={() => setTimeout(() => setDropdownOpen(false), 150)}
                className={`flex items-center gap-1 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  scrolled ? "text-gray-700 hover:text-gray-900" : "text-white hover:text-gray-200"
                }`}
              >
                Categories
                <i className="ri-arrow-down-s-line text-base w-4 h-4 flex items-center justify-center"></i>
              </button>
              {dropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-100 py-1 z-50">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="#articles"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? "text-gray-700 hover:text-gray-900" : "text-white hover:text-gray-200"
              }`}
            >
              Articles
            </a>
            <a
              href="#about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? "text-gray-700 hover:text-gray-900" : "text-white hover:text-gray-200"
              }`}
            >
              About
            </a>
            <a
              href="#contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? "text-gray-700 hover:text-gray-900" : "text-white hover:text-gray-200"
              }`}
            >
              Contact
            </a>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://repsw2c.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-4 py-2 bg-amber-500 text-white text-sm font-semibold rounded-md hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              scrolled ? "text-gray-700" : "text-white"
            }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-3 space-y-2">
            <a href="#home" className="block py-2 text-sm text-gray-700 font-medium cursor-pointer">Home</a>
            <div>
              <p className="py-2 text-sm text-gray-700 font-medium">Categories</p>
              <div className="pl-4 space-y-1">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="block py-1.5 text-sm text-gray-600 cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
            <a href="#articles" className="block py-2 text-sm text-gray-700 font-medium cursor-pointer">Articles</a>
            <a href="#about" className="block py-2 text-sm text-gray-700 font-medium cursor-pointer">About</a>
            <a href="#contact" className="block py-2 text-sm text-gray-700 font-medium cursor-pointer">Contact</a>
            <a
              href="https://repsw2c.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="block w-full text-center py-2 bg-amber-500 text-white text-sm font-semibold rounded-md cursor-pointer"
            >
              Buy It Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
